import { Page } from 'src/context/tracking';
import { useMatch } from 'src/hooks/useMatch';

const useGetCurrentPage = () => {
  const match = useMatch('/:lang?/job/:id/apply/:step');
  const currentStep = match?.params.step;

  switch (currentStep) {
    case 'role-requirements':
      return Page.ROLE_REQUIREMENTS;
    case 'profile':
      return Page.PROFILE_PAGE;
    case 'review':
      return Page.REVIEW_PAGE;
    case 'success':
      return Page.APPLICATION_COMPLETE;
    default:
      return Page.DOCUMENT_PAGE;
  }
};

export { useGetCurrentPage };
